import React from "react";

const Logo = () => {
  return (
    <div className="flex items-center gap-3 group">
      <div className="h-11 w-11 rounded-xl overflow-hidden bg-white dark:bg-card flex items-center justify-center border border-border shadow-xs group-hover:scale-105 transition-transform shrink-0 p-1">
        <img
          src="/assets/img/logo-small.png"
          alt="Easy Retail Flow"
          className="h-full w-full object-contain"
        />
      </div>
      <div className="flex flex-col overflow-hidden text-left">
        <span className="text-base font-bold leading-tight tracking-tight text-foreground truncate group-hover:text-primary transition-colors">
          Easy Retail Flow
        </span>
        <span className="text-[10px] font-semibold text-primary uppercase tracking-wider mt-0.5 whitespace-nowrap">
          Multi-Store POS
        </span>
      </div>
    </div>
  );
};

export default Logo;
